<template>
  <div class="home">
    <Subject name="math" />
    <!-- <div class="title-banner">Easter Egg Numbers</div> -->
    <img class="banner-home" src="@/assets/practices/easter_egg/banner_home_right.svg" alt="banner_home" />
    <button class="start" @click="clickStart">Start</button>
    <div class="assets">
      <!-- <img class="asset bunny" src="@/assets/practices/easter_egg/bunny_sit.svg" alt="bunny_sit"> -->
      <div id="bunny"></div>
      <img
        id="egg-circle"
        class="asset egg"
        src="@/assets/practices/easter_egg/egg_circles_happy.svg"
        alt="egg_circles"
      />
      <img id="egg-crowns" class="asset egg" src="@/assets/practices/easter_egg/egg_crowns.svg" alt="egg_crowns" />
      <img id="egg-fish" class="asset egg" src="@/assets/practices/easter_egg/egg_fish_happy.svg" alt="egg_fish" />
      <img
        id="egg-squares"
        class="asset egg"
        src="@/assets/practices/easter_egg/egg_squares_happy.svg"
        alt="egg_squares"
      />
      <img id="egg-flowers" class="asset egg" src="@/assets/practices/easter_egg/egg_flowers.svg" alt="egg_flowers" />
      <img id="egg-melons" class="asset egg" src="@/assets/practices/easter_egg/egg_melons.svg" alt="egg_melons" />
    </div>
    <!-- Extras -->
    <!-- <img class="asset egg" id="egg-planes" src="@/assets/practices/easter_egg/egg_planes.svg" alt="egg_planes"> -->
    <!-- <img class="asset egg" src="@/assets/practices/easter_egg/egg_spirals.svg" alt="egg_spirals"> -->
    <!-- <img class="asset egg" src="@/assets/practices/easter_egg/egg_stars.svg" alt="egg_stars"> -->
    <!-- <img class="asset egg" src="@/assets/practices/easter_egg/egg_plant.svg" alt="egg_plant"> -->
    <!-- <img class="asset egg" src="@/assets/practices/easter_egg/egg_clouds.svg" alt="egg_clouds"> -->
    <!-- <img class="asset egg" src="@/assets/practices/easter_egg/egg_hearts.svg" alt="egg_hearts"> -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
// import { Howl } from 'howler';
import lottie from 'lottie-web/build/player/lottie';
import sounds from '@/packages/sounds/index.js';

export default {
  name: 'Home',
  components: {
    Subject: () => import('@/components/practices/Subject.vue'),
  },
  computed: {
    ...mapGetters({ homeScreenStatus: 'homeScreenStatus' }),
  },
  mounted() {
    const animation = lottie.loadAnimation({
      container: document.getElementById('bunny'),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: '/assets/practices/easter_egg/animations/bunny_sit.json',
    });
    animation.setSpeed(1);
  },
  methods: {
    ...mapActions({ homeStartClick: 'easterEgg/homeStartClick' }),
    clickStart() {
      sounds.globalButton.play();
      this.homeStartClick();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

@mixin flex {
  display: flex;
  justify-content: center;
}

button {
  background-color: $easter-egg-button-main-color;
  color: #fff;
  padding: 10px 20px;
  border: none;
  border-radius: 999px;
  box-shadow: 5px 10px 0px 0px $easter-egg-button-shadow-color;
  cursor: pointer;
  text-align: center;
}

.home {
  @include flex;
  height: 100vh;
  width: 100vw;
  align-items: center;
}

.title-banner {
  background-image: url('~@/assets/practices/easter_egg/banner_blue.svg');
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 100%;
  // padding-top: 0.25em;
  padding-right: 0.75em;
  // font-size: 1.75em;
  // font-size: 90%;
  text-align: right;
  color: white;
  z-index: 997;
  position: absolute;
  top: 5%;
  right: 0;
  height: 20vh;
  width: 32.5%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.banner-home {
  position: absolute;
  top: 0;
  right: -1vw;
  // width: 70vw;
  height: 25vh;
}

button {
  z-index: 999;
  // font-size: 5vh;
  // height: 8vh;
  width: 28vh;
  padding: 0.25em;
  position: absolute;
  transform: translate(-1vw, 22vh);

  // top: 7%;
  // left: 10%;
}

.asset {
  position: absolute;
}

// .bunny {
//   height: 70vh;
//   z-index: 998;
//   grid-area: bunny;
//   bottom: -50%;
// }

#bunny {
  position: absolute;
  height: 70vh;
  width: 100%;
  z-index: 998;
  bottom: -52%;
  transform: translateX(1vw);
}

.egg {
  height: 40vh;
  animation: egg-dance 1.6s linear infinite;
  position: absolute;
  transform-origin: bottom center;
}

@mixin keyframes($egg-position, $egg-animation) {
  -moz-animation: $egg-animation 1.6s linear infinite;
  -webkit-animation: $egg-animation 1.6s linear infinite;
  animation: $egg-animation 1.6s linear infinite;
  @keyframes #{$egg-animation} {
    0% {
      -moz-transform: translate($egg-position) rotate(-10deg);
      -webkit-transform: translate($egg-position) rotate(-10deg);
      transform: translate($egg-position) rotate(-10deg);
    }
    25% {
      -moz-transform: translate($egg-position) rotate(0deg);
      -webkit-transform: translate($egg-position) rotate(0deg);
      transform: translate($egg-position) rotate(0deg);
    }
    50% {
      -moz-transform: translate($egg-position) rotate(10deg);
      -webkit-transform: translate($egg-position) rotate(10deg);
      transform: translate($egg-position) rotate(10deg);
    }
    75% {
      -moz-transform: translate($egg-position) rotate(0deg);
      -webkit-transform: translate($egg-position) rotate(0deg);
      transform: translate($egg-position) rotate(0deg);
    }
    100% {
      -moz-transform: translate($egg-position) rotate(-10deg);
      -webkit-transform: translate($egg-position) rotate(-10deg);
      transform: translate($egg-position) rotate(-10deg);
    }
  }
}

@keyframes egg-dance {
  0% {
    transform: rotate(-5deg);
  }
  25% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(5deg);
  }
  75% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-5deg);
  }
}

#egg-circle {
  z-index: 1;
  $egg-circle-position: -230%, 30%;
  grid-area: circle;
  // transform: translateY(30%);
  bottom: -30%;
  // @include keyframes($egg-circle-position, egg-circle-animation);
}

#egg-melons {
  z-index: 0;
  $egg-melons-position: -150%, 20%;
  grid-area: melons;
  bottom: -20%;
  // @include keyframes($egg-melons-position, egg-melons-animation);
  animation-delay: -2s;
}

#egg-fish {
  z-index: 1;
  $egg-fish-position: -80%, 40%;
  grid-area: fish;
  bottom: -40%;
  // @include keyframes($egg-fish-position, egg-fish-animation);
  animation-delay: -1s;
}

#egg-squares {
  z-index: 1;
  $egg-squares-position: 80%, 25%;
  grid-area: squares;
  bottom: -25%;
  // @include keyframes($egg-squares-position, egg-squares-animation);
  animation-delay: -2.5s;
}

#egg-flowers {
  z-index: 2;
  $egg-flowers-position: 150%, 40%;
  grid-area: flowers;
  bottom: -40%;
  // @include keyframes($egg-flowers-position, egg-flowers-animation);
  animation-delay: -3s;
}

#egg-crowns {
  z-index: 1;
  $egg-crowns-position: 230%, 20%;
  grid-area: crowns;
  bottom: -20%;
  // @include keyframes($egg-crowns-position, egg-crowns-animation);
  animation-delay: -1.5s;
}

#egg-planes {
  z-index: 0;
  $egg-planes-position: 0, 10%;
  grid-area: planes;
  bottom: -10%;
  // @include keyframes($egg-planes-position, egg-planes-animation);
}

.assets {
  position: absolute;
  justify-content: center;
  align-items: flex-end;
  justify-items: center;
  display: grid;
  height: 50vh;
  min-width: 70vw;
  max-width: 1920px;
  grid-template-areas: 'circle melons fish . squares flowers crowns';
  grid-template-columns: 25vh 25vh 25vh 25vh 25vh 25vh 25vh;
  transform: translateY(-11vh);
  // grid-gap: 50px;
}

@media (min-width: $screen-xs) {
  button {
    font-size: 1em;
  }
}

@media (min-width: $screen-md) {
  button {
    font-size: 1.5em;
  }
  .title-banner {
    font-size: 3em;
  }
}

@media (max-device-aspect-ratio: 8/5) and (min-width: $screen-lg) {
  .assets {
    grid-template-columns: 17.5vh 17.5vh 17.5vh 17.5vh 17.5vh 17.5vh 17.5vh;
  }

  .egg {
    height: 35vh;
  }

  #bunny {
    height: 60vh;
  }

  button {
    font-size: 2.5em;
    width: 18vw;
    transform: translate(-1.75vw, 25vh);
  }
}
</style>
